// This functional component is solely used to allow the react-select elemment contained within to access the light / dark theme toggle of the app at large
import { useMantineColorScheme } from '@mantine/core';
import Reports from '../Admin-Dashboard/Reports';

export default function ReportsWrapper(props) {
  const { colorScheme } = useMantineColorScheme();

  return <Reports {...props} colorScheme={colorScheme} />;
}